import {Observable} from 'rxjs';
import {LoginResponse} from '@/models/response/LoginResponse';
import {$httpClient} from '@/services/httpClient';
import {TokensPayload} from '@/store/modules/authorization/mutations';
import { LOGOUT_WS, REFRESH_TOKEN_WS } from '@/types/authorization.types';
import { BaseResponse } from '@/models/response/base/BaseResponse';

export default class AuthorizationService {
  private readonly baseApi: string;

  constructor() {
    this.baseApi = 'api/session/';
  }

  public logout(): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + LOGOUT_WS);
  }

  public refreshToken(refreshToken: string): Observable<TokensPayload> {
    return $httpClient.post<any>(this.baseApi + REFRESH_TOKEN_WS, {refreshToken});
  }

}
